import React from 'react';
import Tabs from '@material-ui/core/Tabs';
import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles({
    scrollButtons: {
        "&.Mui-disabled": { opacity: 0.3, }
    }
});
function AccomodationTabs(props) {
    const classes = useStyles();
    return (React.createElement(Tabs, { classes: classes, value: props.value, variant: "scrollable", scrollButtons: "on", onChange: props.onChange }, props.children));
}
export default AccomodationTabs;
